export function getSessionItem(key, fallback = null) {
  try {
    return sessionStorage.getItem(key)
  } catch (error) {
    return fallback
  }
}

export function setSessionItem(key, value) {
  try {
    sessionStorage.setItem(key, value)
    return true
  } catch (error) {
    return false
  }
}

export function removeSessionItem(key) {
  try {
    sessionStorage.removeItem(key)
    return true
  } catch (error) {
    return false
  }
}

export function clearSession() {
  try {
    sessionStorage.clear()
    return true
  } catch (error) {
    return false
  }
}

export function readSessionJson(key, fallback = null) {
  const raw = getSessionItem(key)
  if (!raw) {
    return fallback
  }

  try {
    return JSON.parse(raw)
  } catch (error) {
    return fallback
  }
}

export function writeSessionJson(key, value) {
  return setSessionItem(key, JSON.stringify(value))
}
